var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{attrs:{"id":"app-container__footer"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.defaultSetting.copyright)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }